<template>
	<v-navigation-drawer permanent rail :expand-on-hover="canHover" :rail-width="RAIL_WIDTH" :width="260" :color="color" class="nav-rail">
		<div class="nav-rail__header">
			<v-btn v-if="!canHover" icon variant="text" size="small" class="nav-rail__toggle" :title="t('NavMenu')" :aria-label="t('NavMenu')" @click="emit('expand')">
				<v-icon>menu</v-icon>
			</v-btn>
			<button type="button" class="nav-rail__logo" :title="t('Portal')" @click="emit('portal')">
				<img src="/m.eagle/img/portal/MASCOTTE_WHITE.png" alt="eCOS" class="nav-rail__mascot" />
				<img src="/m.eagle/img/portal/logo-white.png" alt="eCOS" class="nav-rail__wordmark" />
			</button>
			<span class="nav-rail__version">{{ version }}</span>
		</div>
		<NavMenuList :menu="menu" :active-view="activeView" @select="emit('select', $event)" />
	</v-navigation-drawer>
</template>

<script setup>
import NavMenuList from './NavMenuList.vue';
import { RAIL_WIDTH } from '@/composables/useAppChrome';
import { useTranslator } from '@/composables/useTranslator';

defineProps({
	menu: { type: Object, required: true },
	activeView: { type: String, default: null },
	canHover: { type: Boolean, default: true },
	version: { type: String, default: '' },
	color: { type: String, default: 'primary' },
});
const emit = defineEmits(['select', 'portal', 'expand']);

const t = useTranslator();
</script>
